<template>
  <div>
    <div class="text-center py-2 text-caption" style="background: rgb(0 0 0)">Sabong World Wide Live</div>
    <div class="d-flex justify-space-between text-right py-3 px-2" style="background: rgb(0 0 0)">
      <div class="d-flex align-center">
        <v-btn elevation="2" outlined small class="mr-2">
        <span style="color: #9a9da2" class="caption" @click="goTo('/Withdraw')"
          >WITHDRAW</span
        >
      </v-btn>
        <v-btn elevation="2" outlined small>
        <span style="color: #9a9da2" class="caption" @click="goTo('/help')"
          >RULES</span
        >
      </v-btn>
      </div>
      <v-menu offset-y>
        <template   class="pl-3" v-slot:activator="{ on, attrs }">
          <v-btn color="#1e2024" v-bind="attrs" v-on="on" depressed>
            <span style="color: #ffdc11"
              >MENU<v-icon class="mr-1" style="color: #ffdc11"
                >mdi-menu-down</v-icon
              ></span
            >
          </v-btn>
        </template>
        <v-list color="rgb(16 16 16)">
          <v-list-item-title class="pb-3">
            <span class="pl-2 caption yellow--text text--darken-1">{{ user.name }}</span>
          </v-list-item-title>

          <hr />

          <v-list-item v-for="(item, index) in items" :key="index">
            <v-list-item-title class="grey--text" @click="goTo(item.link)">{{
              item.title
            }}</v-list-item-title>
          </v-list-item>

          <v-list-item-title class="grey--text pl-4 pt-2 pb-3" @click="logout"
            >Logout</v-list-item-title
          >
        </v-list>
      </v-menu>
    </div>
  </div>
</template>


<script>
export default {
  props: ["user"],
  data: () => ({
    items: [
      // { title: "Promos", link: "/promo" },
      { title: "Betting History", link: "/bet-history" },
      { title: "Add Points", link: "/add-credits" },
      { title: "Withdraw", link: "/withdraw" },
      // { title: 'View Commissions',link: '/commission' },
      // { title: 'Invite Friends',link: '/invite' },
      { title: "Rules", link: "/help" },
      { title: "Account Details", link: "/settings" },
    ],
  }),
  methods: {
    goTo(path) {
      if(!this.user.mobile_verified && (path === "/Withdraw" || path === "/withdraw")){
        this.$router.push({ path: "/verify" }).catch(() => {
          this.drawer = false;
        });
      }else{
        this.$router.push({ path: path }).catch(() => {
          this.drawer = false;
        });
      }
    },
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.axios.defaults.headers.common["Authorization"] = null;
      this.$router.push({ name: `login` });
    },
  },
};
</script>
